const getChineseNumber = (n) => {
  // 最多5年
  const num = Math.min(5, n);
  const arr = ["一", "二", "三", "四", "五"];
  return arr[num - 1];
};

export default getChineseNumber;
